// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-windowbody_container__hx4v5","fullWidth":"idt-windowbody_fullwidth__28l2b","desktop":"idt-windowbody_desktop__2dgsa"};